import { useState } from 'react';

export default function CollapsibleInfoPanel({ title, children, defaultOpen = true }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="relative w-full p-1">
      <button
        onClick={() => setIsOpen(prev => !prev)}
        aria-expanded={isOpen}
        className="relative w-full p-1 text-left"
      >
        {`${(isOpen ? '[-] HIDE ' : '[+] SHOW')} ${title}`}
      </button>

      <div
        className={`absolute top-full left-0 w-full z-20 overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen 
            ? 'bg-white/70 backdrop-blur-sm border-b border-gray-200 translate-y-0 pointer-events-auto' 
            : 'max-h-0 opacity-0 -translate-y-2 pointer-events-none'
        }`}
      >
        <div className="p-4 m-2 shadow-xl border border-gray-200 text-black text-center">
          {children}
          <div className="p-1">
            <button
              onClick={() => setIsOpen(prev => !prev)}
              aria-expanded={isOpen}
              className="btn text-center text-gray-100"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}